import CustomApplicationState from "@theStellarBlueprint/Store/CustomApplicationState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsState";

export const getCuttingToolCurrentPageState = (state: CustomApplicationState) => {
    return state?.StellarState?.CuttingToolPagination;
}

export const getCuttingToolPaginationDataByCategoryId = (state: CustomApplicationState) => {
const productDataView = state.data.products.dataViews;
const categoryId = state?.StellarState?.CuttingToolCategoryId.categoryId;
let selectedCategoryData :ProductsDataView | undefined= undefined;
if(categoryId){
    for (let x in productDataView) {
        if(x.includes("categoryId")){
            const categoryIdInObj = x.split("&")[2].split("=")[1]
            if(categoryIdInObj===categoryId){
                selectedCategoryData=productDataView[x]
            }
        }
       
      }
      return selectedCategoryData;
}else{
    return null;
}


    // const productDataViewArr = Object.values(state.data.products.dataViews);
    // if (productDataViewArr.length > 0) {
    //     return productDataViewArr;
    // } else {
    //     return null;
    // }


}
